import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=f70dac0c&scoped=true"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"
import style0 from "./UploadImages.vue?vue&type=style&index=0&id=f70dac0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70dac0c",
  null
  
)

export default component.exports